import { HttpStatusCode } from "axios";
import { IErrors } from "interfaces/IErrors";

/**
 * Basic response props required for the HttpResponse constructor
 */
interface IResponse<TData> {
    /**
     * Custom data
     */
    data?: TData;
    /**
     * Basic response status
     */
    success?: boolean;
    /**
     * Http status code
     */
    statusCode?: HttpStatusCode;
    /**
     * The errors array from endpoint
     */
    result?: IErrors;
}
/**
 * Custom HttpResponse obtain from a HTTP request
 */
export class HttpResponse<TData> {
    /**
     * The status code obtain from the HTTP response
     */
    statusCode: HttpStatusCode;
    /**
     * The success status when everything was right
     */
    success: boolean = true;
    /**
     * The data provided from the HTTP response
     */
    data?: TData = undefined;
    /**
     * The errors array from endpoint
    */
    result: IErrors;
    /**
     * Default constructor
     * @param props The {@link IResponse} props for the constructor
     */
    private constructor({ data, success, statusCode, result }: IResponse<TData>) {
        this.data = data ?? undefined;
        this.statusCode = statusCode ?? HttpStatusCode.Ok;
        this.success = success ?? true;
        this.result = result ?? { errors: {} }
    }
    /**
     * Creates a {@link HttpResponse} class when the API request was success
     * @param data 
     * @returns A basic response with the data required
     */
    static ok<TData>(data: TData) {
        return new HttpResponse<TData>({ data });
    }
    /**
     * Creates a {@link HttpResponse} class when the API request failed
     * @param result The result type event return by api
     * @param statusCode A status code if required
     * @returns A fail response with the result return
     */
    static error<TData>( result: IErrors, statusCode: HttpStatusCode = HttpStatusCode.BadRequest) {
        return new HttpResponse<TData>({ result, statusCode, success: false });
    }
}